// tslint:disable: trailing-comma
// tslint:disable:no-any
import { UnitV2 } from '../common/unit-v2';

export interface UnitsResponseV2 {
  count: number;
  units: UnitV2[];
}
